import { flatMap } from "lodash";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useTranslation } from "react-i18next";
import { Item } from "../../../../common/models";
import { STEPS } from "../../constants";
import { SpacePurpose } from "../../models";
import { useSetUpSpacesStore } from "../../store";
import SpaceNames from "./SpaceNames";
import SubSpaceNames from "./SubSpaceNames";

interface SpacePurposesTableProps {
    isReadOnly?: boolean;
    openAddNewSubSpace?: (spacePurpose: SpacePurpose) => void;
    subSpacePurposesOptions?: Item[];
}

const SpacePurposesTable = (props: SpacePurposesTableProps) => {
    const {
        isReadOnly,
        openAddNewSubSpace = () => {},
        subSpacePurposesOptions,
    } = props;

    const { spacePurposes, removeSpacePurpose, step } = useSetUpSpacesStore();

    const { t } = useTranslation("setUpSpaces");

    const NameBody = (spacePurpose: SpacePurpose) => {
        return (
            <div className="flex flex-col">
                {spacePurpose.name}
                <div className="font-normal text-sm text-default/60">
                    {flatMap(spacePurpose.subSpacePurposes, "name").join(", ")}
                </div>
            </div>
        );
    };

    const SubSpacesBody = (spacePurpose: SpacePurpose) => (
        <SubSpaceNames
            spacePurpose={spacePurpose}
            isReadOnly={isReadOnly}
            openAddNewSubSpace={() => openAddNewSubSpace(spacePurpose)}
            subSpacePurposesOptions={subSpacePurposesOptions}
        />
    );

    const RemoveActionBody = (spacePurpose: SpacePurpose) => (
        <Button
            className="text-default"
            icon="pi pi-times"
            rounded
            text
            severity="secondary"
            aria-label="cross icon"
            onClick={() => removeSpacePurpose(spacePurpose)}
        />
    );

    const SpacesBody = (spacePurpose: SpacePurpose) => (
        <SpaceNames spacePurpose={spacePurpose} isReadOnly={isReadOnly} />
    );

    return (
        <>
            {!!spacePurposes.length && (
                <DataTable
                    emptyMessage={t("common:noResultsFound")}
                    value={spacePurposes}
                >
                    <Column
                        header={t("spacePurposes.spacePurpose")}
                        className="font-bold"
                        pt={{
                            bodyCell: { className: "!py-1" },
                        }}
                        body={NameBody}
                        key="spacepurposestable-column-1"
                    />
                    {step === STEPS.ADD_SPACE_PURPOSES && (
                        <Column
                            header={t("spacePurposes.subSpaces")}
                            body={SubSpacesBody}
                            pt={{
                                bodyCell: { className: "!py-1" },
                            }}
                            key="spacepurposestable-column-2"
                        />
                    )}
                    {step === STEPS.ADD_SPACE_PURPOSES && (
                        <Column
                            body={RemoveActionBody}
                            align="right"
                            pt={{
                                bodyCell: { className: "!py-1" },
                            }}
                            key="spacepurposestable-column-3"
                        />
                    )}
                    {(step === STEPS.ASSIGN_SPACES ||
                        step === STEPS.SUMMARY) && (
                        <Column
                            header={t("spacePurposes.spaces")}
                            body={SpacesBody}
                            pt={{
                                bodyCell: { className: "!py-1" },
                            }}
                            key="spacepurposestable-column-4"
                        />
                    )}
                </DataTable>
            )}
        </>
    );
};

export default SpacePurposesTable;
